import { useGetTypesQuery } from '../service';

interface UseTypesProps {
  search?: string;
  page?: number;
  pageSize?: number;
}

const useTypes = ({ search, page = 1, pageSize = 5 }: UseTypesProps = {}) => {
  const { data, isLoading, error } = useGetTypesQuery({
    search: search || '',
    paginated: {
      page,
      pageSize,
    },
  });

  return {
    types: data?.items || [],
    isLoading,
    error,
  };
};

export default useTypes;
